/**
 * @generated SignedSource<<5bda21f6f75f4cefb98a63bf8e58814a>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type EventAttendButtonNew_query$data = {
  readonly viewer: {
    readonly id: string;
  } | null | undefined;
  readonly " $fragmentType": "EventAttendButtonNew_query";
};
export type EventAttendButtonNew_query$key = {
  readonly " $data"?: EventAttendButtonNew_query$data;
  readonly " $fragmentSpreads": FragmentRefs<"EventAttendButtonNew_query">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "EventAttendButtonNew_query",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "User",
      "kind": "LinkedField",
      "name": "viewer",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "id",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Query",
  "abstractKey": null
};

(node as any).hash = "390a3f37f91dca6c942a87ee9e861e4b";

export default node;
